import { USER_FIRST_NAME_ERR_MSG_LENGTH } from 'constants/validMsg.js';
import { USER_FIRST_NAME_ERR_MSG_NUMBER } from 'constants/validMsg.js';
import { USER_FIRST_NAME_ERR_MSG_SYMBOL } from 'constants/validMsg.js';
import { USER_FIRST_NAME_ERR_MSG_SPACE } from 'constants/validMsg.js';

/**
 * @param {string} value
 * @returns {Object} result - error message with boolean type.
 */
const validateFirstName = (value) => {
	let result = { isErr: false, errMsg: '' };

	if (value.length === 0) {
		return result;
	} else if (value.length < 3 || value.length > 24) {
		result = { isErr: true, errMsg: USER_FIRST_NAME_ERR_MSG_LENGTH };
		return result;
	} else if (value.length > 3 || value.length < 24) {
		const numberCount = (value.match(/[0-9]/g) || []).length;
		const symbolCount = (value.match(/[!$%^&*()_+|~=`{}[\]:";<>?./@]/g) || []).length;
		const spaceCount = (value.match(/[\s]{2,}/g) || []).length;

		if (numberCount > 0) {
			result = { isErr: true, errMsg: USER_FIRST_NAME_ERR_MSG_NUMBER };
			return result;
		} else if (symbolCount > 0) {
			result = { isErr: true, errMsg: USER_FIRST_NAME_ERR_MSG_SYMBOL };
			return result;
		} else if (spaceCount > 0) {
			result = { isErr: true, errMsg: USER_FIRST_NAME_ERR_MSG_SPACE };
			return result;
		} else {
			return result;
		}
	}
};

export default validateFirstName;
